import { useCallback, useState } from "react";
import axios from "axios";
import { useMessage } from "./useMessage";
import { useLoginUser } from "./useLoginUser";
import appconfig from "../config.json";

export const useEventBridge = () => {
  const { tokenRefresh } = useLoginUser();
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);

  const API_MANAGER_URL: string = appconfig["IOT_MANAGEMENT_API_URL"];

  const executeStateMachine = useCallback(async (stateMachineArn: string, input: any) => {
    setLoading(true);
    
    try {
      const token = await tokenRefresh();
      
      // 実行名を生成（タイムスタンプ付き）
      const executionName = `manual-${Date.now()}`;
      
      // inputがオブジェクトの場合はJSON文字列に変換
      let inputString: string;
      if (typeof input === 'string') {
        // 文字列の場合、空文字列なら空オブジェクトを使用
        inputString = input.trim() === '' ? '{}' : input;
      } else if (input === null || input === undefined) {
        // null/undefinedの場合は空オブジェクト
        inputString = '{}';
      } else {
        // オブジェクトの場合はJSON文字列に変換
        inputString = JSON.stringify(input);
      }
      
      const response = await axios.post(
        `${API_MANAGER_URL}/stepfunctions/execute`,
        {
          stateMachineArn,
          name: executionName,
          input: inputString
        },
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        }
      );

      showMessage({
        title: "実行開始",
        description: "Step Functionの実行を開始しました",
        status: "success",
      });

      return response.data;
    } catch (error: any) {
      console.error('Step Function execution error:', error);
      console.error('Error response:', error.response?.data);
      
      const errorMessage = error.response?.data?.message || error.message || "Step Functionの実行に失敗しました";
      
      showMessage({
        title: "実行エラー",
        description: errorMessage,
        status: "error",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  }, [tokenRefresh, showMessage]);

  return {
    executeStateMachine,
    loading,
  };
};
